import React from "react";
import { useNavigate } from "react-router-dom";
import appConfig from "@config/app.config.json";
import { ButtonOr, ButtonGroup } from "semantic-ui-react";
import { Div, Button } from "@components/Generics.react";

export default function LogoutPage() {
  const navigate = useNavigate();
  const { colors } = appConfig;

  const serverLogout = async () => {
    localStorage.removeItem("accessToken");

    // Prevent back navigation
    window.history.pushState(null, "", "/login");
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };

    navigate("/login", { replace: true });
  };

  return (
    <Div
      style={{
        background: `linear-gradient(to left top, #00000033, #000000cc), ${colors.main}`,
      }}
      fluid
      flex
      column
      ht="92vh"
      primary
      center-align
    >
      <Div txtWhite headline altText gutter>
        Are you sure you want to Logout?
      </Div>
      <Div wd="15%">
        <ButtonGroup fluid>
          <Button content={"No"} onClick={() => navigate(-1)} />
          <ButtonOr />
          <Button danger content={"Yes"} onClick={serverLogout} />
        </ButtonGroup>
      </Div>
    </Div>
  );
}
